/**
 * Subscription stores module
 * Contains all stores related to subscription management
 */

import { usePlansStore } from './plans'
import { useCustomerStore } from './customer'
import { usePaymentMethodsStore } from './paymentMethods'
import { useSubscriptionsStore } from './subscriptions'
import { usePaymentsStore } from './payments'

// Re-export all subscription stores
export { usePlansStore } from './plans'
export { useCustomerStore } from './customer'
export { usePaymentMethodsStore } from './paymentMethods'
export { useSubscriptionsStore } from './subscriptions'
export { usePaymentsStore } from './payments'

/**
 * Initialize all subscription-related data
 * Fetches plans, customer, payment methods, and subscriptions in parallel
 */
export async function initializeSubscriptionData() {
  const plansStore = usePlansStore()
  const customerStore = useCustomerStore()
  const paymentMethodsStore = usePaymentMethodsStore()
  const subscriptionsStore = useSubscriptionsStore()

  // eslint-disable-next-line no-useless-catch
  try {
    await Promise.all([
      plansStore.fetchPlans(),
      customerStore.fetchCustomer(),
      paymentMethodsStore.fetchPaymentMethods(),
      subscriptionsStore.fetchSubscriptions()
    ])
  } catch (error) {
    throw error
  }
}

/**
 * Initialize payments data
 * Fetches payment history and status counts
 */
export async function initializePaymentsData() {
  const paymentsStore = usePaymentsStore()

  // eslint-disable-next-line no-useless-catch
  try {
    await paymentsStore.initializePaymentsData()
  } catch (error) {
    throw error
  }
}

